import styled from 'styled-components';
import { Row, Col } from 'antd';

export const DataTableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 50px;
  background-color: #fff;
  padding: 10px;
  display: flex;
  margin-bottom: 10px;
`;

export const Header = styled.span`
  font-size: 1.1em;
  text-align: left;
  margin-left: 0.4em;
  width: 50%;
  display: inline-block;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const ButtonWrapper = styled.span`
  display: flex;
  justify-content: flex-end;
  width: 50%;
`;

export const ConfigContainerWrapper = styled.div`
  background-color: #fff;
  display: flex;
  height: 300px;
  overflow: hidden auto;
`;

export const NewConfigPanelWrapper = styled.div`
  height: 300px;
  overflow: hidden auto;
`;

export const RowWrapper = styled.div`
  background-color: #fff;
  width: 100%;
  display: inline;
`;

export const StyledRow = styled(Row)`
  display: inline;
`;

export const RowLabel = styled.span`
  font-size: 1.2em;
`;

export const StyledCol = styled(Col)`
  display: inline-block;
  margin: 5px;
  max-width: 200px;
`;

export const StyledSingleSelectDropdown = styled.div`
  width: 105px;
`;

export const StyledPara = styled.p`
  font-size: 14px;
`;

export const StyledFooter = styled.p`
  font-size: 13px;
  font-style: italic;
  font-weight: 100;
  text-align: left;
`;

export const StyledErrorMsg = styled.p`
  font-size: 13px;
  font-weight: 100;
  text-align: left;
  color: red;
`;
